import { createAction, props } from '@ngrx/store';

export const initDashboard = createAction('[Dashboard Page] Init');

//Action for getDashboardData.
export const getDashboardData = createAction('[Dashboard/API] getDashboardData');
export const getDashboardDataSuccess = createAction(
  '[Dashboard/API] getDashboardData Success',
  props<{ userDashboardData: any }>()
);
export const getDashboardDataFailure = createAction(
  '[Dashboard/API] getDashboardData Failure',
  props<{ error: any }>()
);

export const clearUserDashboardData = createAction('[Dashboard/API] Clear Dashboard Data');

// Force change password modal
export const openChangePasswordModal = createAction(
  '[Dashboard/API] Open Force change password Modal',
  props<{ emailId: any; actionLabel: any }>()
);
export const openChangePasswordModalSuccess = createAction(
  '[Dashboard/API] Open Force change password Modal success',
  props<{ modalData?: any }>()
);
